import Decimal from 'decimal.js';
import { TokenInfo, OrderBook } from '../types';

// Use relative URLs since frontend and backend are served from the same server
const API_BASE_URL = '/api';

export class ApiService {
    private baseUrl: string;

    constructor(baseUrl: string = API_BASE_URL) {
        this.baseUrl = baseUrl;
    }

    async getAssets(): Promise<TokenInfo[]> {
        const response = await fetch(`${this.baseUrl}/assets`);
        if (!response.ok) {
            throw new Error(`Failed to fetch assets: ${response.statusText}`);
        }
        
        const data = await response.json();
        return data.assets;
    }

    async getOrderBook(mint: string): Promise<{ asset: TokenInfo; orderBook: OrderBook }> {
        const response = await fetch(`${this.baseUrl}/orderbook/${mint}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch order book for ${mint}: ${response.statusText}`);
        }
        
        const data = await response.json();
        
        // Convert string decimals to Decimal objects
        const orderBook: OrderBook = {
            ...data.orderBook,
            bids: data.orderBook.bids.map((level: any) => ({
                price: new Decimal(level.price),
                quantity: new Decimal(level.quantity),
            })),
            asks: data.orderBook.asks.map((level: any) => ({
                price: new Decimal(level.price),
                quantity: new Decimal(level.quantity),
            })),
            midPrice: new Decimal(data.orderBook.midPrice),
            spread: new Decimal(data.orderBook.spread),
        };

        return {
            asset: data.asset,
            orderBook,
        };
    }

    async getHealth(): Promise<any> {
        const response = await fetch(`${this.baseUrl}/health`);
        if (!response.ok) {
            throw new Error(`Health check failed: ${response.statusText}`);
        }
        
        return response.json();
    }

    async getSessionStats(): Promise<any> {
        const response = await fetch(`${this.baseUrl}/sessions/stats`);
        if (!response.ok) {
            throw new Error(`Failed to fetch session stats: ${response.statusText}`);
        }
        
        return response.json();
    }
}

export const apiService = new ApiService(); 
